/* eslint-disable no-debugger */
/* eslint-disable max-nested-callbacks */
/* eslint-disable no-console */
/* eslint-disable complexity */
/**
 * @author sunzhiguang
 * @date 2020/7/6
 */

/**
 * 消息盒子容器组件， 所有消息记录会在这里
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react";
import MessageBox from "@/components/chat/message/Box";
import Loading from "@/components/Loading";
import { MessageSendType } from "@/types/chat/enum";
import SimpleTime from "@/components/chat/message/Time/Simple";
import "./index.less";
import ChatState, { AITabState, SessionMessageMap } from "@/types/chat/State";
import { connect } from "dva";
import TimeLine from "@/components/chat/message/Time/Line";
import ImService from "@/server/ImService";
import { isSameDay } from "@/utils/date";
import {
  ChatMessage,
  Employee,
  LoadHistoryOptions,
  MessageEmitCategory,
  MessageReadScene,
  NoticeMessageRespType,
  Session
} from "@/types/chat";
import { isChatPage, usePrevious } from "@/utils/chat/index";
import {
  checkSysMessage,
  employeeToUid,
  filterNoticeMassagesByType,
  isDownloadSysMesssage,
  isEqualEmployee,
  isSnapchatTimeSysMesssage,
  sleep
} from "@/utils/chat/message";
import Context from "@/components/chat/context";
import bus from "@/utils/bus";

import CHAT_NOTICE, { OTHER_EXCLUDE_TABS_PIN, TYPE_KEY_SHARE_GREET_MULTI } from "@/contant/chat";
import classNames from "classnames";
import {
  isAIChatNoticeSessionId,
  isAIChatSession,
  isAINoticeSession,
  isCustomAppSession,
  isOrgChatSession
} from "@/utils/chat/session";
import { MessageStatus } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import IconFont from "@/components/icon";
import { FocusSDK, isFocusEnv } from "@/utils";
import { debounce, throttle, values } from "lodash";
import GoEnd from "../GoEnd";
import aiNoData from "@/assets/img/empty/ai-no-data.png";
import ChattingRecordsModal from "../InviteForward/ChattingRecordsModal";
import { FloatButton } from "@/baseComponents/FloatButton";
import { convertUidToString } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import QuestionOperation from "@/baseComponents/Chat/QuestionOperation";
import AISummaryControl from "@/baseComponents/Chat/AIMessageSummaryBtn";
import { isShareHintMultiMessage, MAX_AI_UNREAD_COUNT } from "@/utils/chat";
import { getShareHintMessageBody } from "../../utils/commonMessageModal";
import { transformUserDataToWorkUserInfo } from "@/components/Calendars/View/common/QuickCreateModal/DatePicker/utils";
import { isInViewPortOfOne } from "@/utils/tools";
interface MessageBoxContainerProps {
  msgNodes: Array<ReactNode>;
  sendType: MessageSendType;
  selectedAITab: AITabState;
  sessionMessageMap: SessionMessageMap;
  preSelectedSessionId: string;
  lastUnreadMessage?: any;
  storePreSelectedSession: Session;
  readMsgCustom: string;
  customAppList: Session[];
  llmSetting: any;
}

interface DvaDispatchProps {
  setHistoryMessage: Function;
  updateSelectedAITab: Function;
  updatePreAISessionMsg: Function;
  initSelectedSession: Function;
  updateSessionEvent: Function;
  launchNoticeSession: Function;
  updateSelectSessionInfo: Function;
  setStartMessageId: Function;
}

type IMessageBoxContainerProps = Readonly<MessageBoxContainerProps & ChatState & DvaDispatchProps>;

const getSimpleTimeNode = (messages: ChatMessage[], prevMessages: ChatMessage[]): ReactNode => {
  const timestamp = messages[0].timestamp;
  let prev_timestamp = Date.now();
  if (prevMessages?.length) {
    prev_timestamp = prevMessages[prevMessages.length - 1].timestamp;
  }
  if (!isSameDay(timestamp, prev_timestamp)) {
    return (
      <div>
        {/* <TimeLine timeStamp={timestamp} /> */}
        <SimpleTime timeStamp={timestamp} />
      </div>
    );
  } else {
    if (timestamp - prev_timestamp > 60 * 1000) {
      return <SimpleTime timeStamp={timestamp} />;
    } else {
      return <div />;
    }
  }
};

let unreadMsgs: any;

const getMessageNode = ({
  messages,
  getLock,
  unLock,
  getCurrentMessageId,
  setCurrentMessageId,
  session,
  currentEmployee,
  observer,
  sText,
  sMid,
  tempMsgs
}: {
  messages: ChatMessage[];
  getLock: Function;
  unLock: Function;
  getCurrentMessageId: Function;
  setCurrentMessageId: Function;
  session: any;
  currentEmployee: Employee;
  updateSessionMessagesTimestamp: number;
  observer?: IntersectionObserver;
  sText?: string;
  sMid?: number;
  tempMsgs: any[];
}) => {
  // console.log('getMessageNode', updateSessionMessagesTimestamp);
  if (!messages.length) {
    return [];
  }
  const groups: Array<ChatMessage[]> = [];
  let temp: ChatMessage[] = [];
  messages.forEach((m: ChatMessage) => {
    if (
      isAIChatSession(session) &&
      (m as any).type === NoticeMessageRespType.UNIFIED_NOTICE_MESSAGE
    ) {
      return;
    }
    if (m && m.category === MessageEmitCategory.SYSTEM) {
      if (!checkSysMessage({ message: m, session })) return;
    }
    // 解决群成员可以看到本地发送失败的消息问题
    if (m.statusType === MessageStatus.FAILED && m.localSendTimestamp) {
      if (!m.sender?.userId) {
        const user = (m.belong || "").split(":") || [];
        m.sender = { ...m.sender, userId: user[0], app: user[1], teamId: user[2] };
      }
      if (!isEqualEmployee(m.sender, currentEmployee)) {
        return;
      }
    }
    if (!temp.length) {
      temp.push(m);
      return;
    }
    if (m.groupId !== temp[temp.length - 1].groupId) {
      groups.push([...temp]);
      temp = [m];
      return;
    }
    temp.push(m);
  });
  if (temp.length) {
    groups.push([...temp]);
  }
  return groups.map((messages, index) => {
    if (!messages[0].id) {
      return <div key={index} />;
    }
    if (session.unnreadCountPseudo && !unreadMsgs) {
      const count = Number(`-${session.unnreadCountPseudo}`);
      unreadMsgs = messages.slice(count);
    }
    return (
      <div key={`key-${messages[0].id}`} id={"id-" + messages[0].id}>
        {index > 0 ? (
          getSimpleTimeNode(messages, groups[index - 1])
        ) : (
          <SimpleTime timeStamp={messages[0].timestamp} />
        )}
        <MessageBox
          unreadFistMsgId={unreadMsgs ? unreadMsgs[0]?.id : 0}
          key={`k-${messages[0].id}`}
          messages={messages}
          getLock={getLock}
          unLock={unLock}
          observer={observer}
          getCurrentMessageId={getCurrentMessageId}
          setCurrentMessageId={setCurrentMessageId}
          session={session}
          sText={sText}
          sMid={sMid}
        />
      </div>
    );
  });
};

function MessageBoxContainer(props: IMessageBoxContainerProps) {
  const mountedRef = useRef(false);
  const scrollRef = useRef(null);
  const wrapRef = useRef(null);
  const {
    selectedSession,
    sessionMessages,
    setHistoryMessage,
    initSelectedSession,
    mainWinShow,
    updateSelectedAITab,
    selectedAITab,
    sessionMessageMap,
    preSelectedSessionId,
    updatePreAISessionMsg,
    prevAISessionMessages,
    sMid,
    sText,
    sTimestamp,
    updateSessionMessagesTimestamp,
    updateSessionEvent,
    launchNoticeSession,
    lastUnreadMessage,
    updateSelectSessionInfo,
    customAppList,
    readMsgCustom,
    llmSetting,
    skipAnchorId,
    setStartMessageId
  } = props;
  const { currentEmployee, lastAIMessage, isLLMAI } = React.useContext(Context);
  const sessionId = selectedSession.sessionId;
  const prevSessionMessagesRef = useRef<any>(null); // 未读消息数组
  const canUnreadBtnRef = useRef(false); // 首次进入会话 底部消息状态
  const loadGreetRef = useRef(false);
  const [end, setEnd] = useState(0);

  const currPage = useRef(0);
  const canShortcut = useRef(true);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [firstLoading, setFirstLoading] = useState(false);
  const [loadingAgain, setLoadingAgain] = useState(false);
  const [isShowBackBottom, setShowBackBottom] = useState(false);

  const [isMousedown, setonMousedown] = useState(false);

  const prevSessionMessages = usePrevious(sessionMessages || []) || [];
  const preSelectedAIPIN = usePrevious(selectedAITab?.pin || "");
  // 之前sessionId
  const preSessionId = usePrevious(selectedSession?.sessionId || "");

  if (isAINoticeSession(selectedSession) && !prevAISessionMessages.length) {
    updatePreAISessionMsg({
      prevAISessionMessages: selectedSession ? sessionMessageMap[selectedSession.sessionId] : []
    });
  }
  const preSelectSession = usePrevious(selectedSession || {});
  const preCustomAppList = usePrevious(customAppList || []);
  const preMainWinShow = usePrevious(mainWinShow);
  const lastMessage = useMemo(() => {
    const last = (sessionMessages || []).slice(-1)[0] || {};
    return last;
  }, [sessionMessages]);

  const prevLastMessage = useMemo(() => {
    const lastPre = (prevSessionMessages || []).slice(-1)[0] || {};
    return lastPre;
  }, [prevSessionMessages]);

  const firstMessage = useMemo(() => {
    const first = (sessionMessages || [])[0] || {};
    return first;
  }, [sessionMessages]);

  const prevFirstMessage = useMemo(() => {
    const firstPre = (prevSessionMessages || [])[0] || {};
    return firstPre;
  }, [prevSessionMessages]);

  const lastLocalMsgRef = useRef<any>(null);
  const lastLocalElRef = useRef<any>(null);
  const preScrollTop = useRef<number>(0);

  const lastPlusCount = useMemo(() => {
    return lastMessage?.plusList?.length || 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastMessage?.plusList?.length]);

  const preLastPlusCount = usePrevious(lastPlusCount || 0);

  const showBottomTimerRef = useRef<any>(null);

  const scrollInToView = useCallback((options?: any) => {
    const curr: any = scrollRef.current;
    if (!curr) {
      return;
    }
    const scrollHeight = curr.scrollHeight;
    curr.scroll({ top: options?.top || scrollHeight, ...options });
  }, []);

  const currentMessageIdRef = useRef("");

  const setCurrentMessageId = useCallback((messageId) => {
    currentMessageIdRef.current = messageId;
  }, []);

  const getCurrentMessageId = useCallback(() => {
    return currentMessageIdRef.current;
  }, []);

  const lockRef = useRef(false);
  const firstRef = useRef(true);
  const bottomEnd = useRef(0);

  const getLock = useCallback((lock?: boolean): boolean => {
    if (lockRef.current) {
      return false;
    }
    if (lock) {
      lockRef.current = true;
    }
    return true;
  }, []);

  const unLock = useCallback(() => {
    lockRef.current = false;
  }, []);

  const readAllMessage = useCallback(() => {
    if (!sessionId || !mainWinShow || (isChatPage() && !FocusSDK?.isChatWinFocus())) {
      return;
    }
    const count = selectedSession.unreadCount;
    // 设用imService readAll接口
    const imService = ImService.getInstance();
    const filtersId = customAppList.map((item) => item.sessionId);
    imService
      .readAllMessage(sessionId, MessageReadScene.ENTER, count !== 0, filtersId)
      .catch((err) => console.warn("imService-readAllMessage-err", err));
  }, [sessionId, mainWinShow, selectedSession.unreadCount, customAppList]);

  const doReadAll = debounce(readAllMessage, 300);

  const readUnreaddMessage = useCallback(async () => {
    // 如果当前窗口是聊天窗口但是没有show也不处理
    if (
      !selectedSession.sessionId ||
      !mainWinShow ||
      (isChatPage() && !FocusSDK?.isChatWinFocus())
    ) {
      return;
    }
    // const msgs = sessionMessages
    //   .filter((i) => i.readNum === 0 && !isEqualEmployee(currentEmployee, i.sender))
    //   .sort((a, b) => a.mid - b.mid);
    const filterFn = (i: any) => {
      if (selectedSession.isGroup) {
        return (
          i.readNum === 0 &&
          !isEqualEmployee(currentEmployee, i.sender) &&
          // selectedSession.lastReadMid < i.mid
          (selectedSession.lastReadMid < i.mid || !selectedSession.lastReadMid)
        );
      } else {
        return i.readNum === 0 && !isEqualEmployee(currentEmployee, i.sender);
      }
    };
    console.log("sessionMessages=>", sessionMessages);
    console.log("selectedSession=>", selectedSession);
    const msgs = sessionMessages.filter(filterFn).sort((a, b) => a.mid - b.mid);
    // 设用imService readAll接口
    if (!msgs.length) {
      return;
    }
    const imService = ImService.getInstance();
    imService.readBatchMessage(msgs, selectedSession);
    // 更新会话的未读数时把@也清空一下，解决滚动时@不消失的问题-xly
    updateSessionEvent({
      session: {
        sessionId: selectedSession.sessionId,
        unreadCount: 0,
        lastReadMid: selectedSession.lastMid,
        mentions: {}
      }
    });
    FocusSDK.sendIpcMessage("read-unread-batch", {
      session: { ...selectedSession, unreadCount: 0 }
    });
  }, [currentEmployee, selectedSession, sessionMessages, updateSessionEvent, mainWinShow]);

  const doReadUnread = debounce(readUnreaddMessage, 300);

  const scrollBottom = debounce(
    useCallback(
      (force = true, offset = 10, read = true) => {
        const curr: any = scrollRef.current;
        if (!curr) {
          return;
        }
        const scrollHeight = curr.scrollHeight;
        const scrollTop = curr.scrollTop;
        const clientHeight = curr.clientHeight;
        // 超出阈值则不滚动，默认用户在自己浏览消息
        if (canUnreadBtnRef.current && !force && scrollHeight - clientHeight - scrollTop > 200) {
          checkScroller();
          return;
        }
        if (read) {
          doReadUnread();
          unreadCountRef.current = 0;
        }
        curr.scroll({ top: scrollHeight - offset });
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [doReadUnread]
    ),
    60
  );

  useEffect(() => {
    FocusSDK.on("chat-win-show", () => {
      doOnMainWinShow();
    });
    return () => {
      FocusSDK.off("chat-win-show", () => {
        doOnMainWinShow();
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMsgEl = (id: string) => {
    const wrap: any = wrapRef.current;
    if (!wrap) {
      return null;
    }
    let ele = wrap.querySelector(`#id-${id}`);
    if (!ele) {
      ele = document.getElementById(`${id}`);
    }
    if (!ele) {
      ele = wrap.querySelectorAll(`div[id^='item-${id}`);
      if (ele?.length) {
        ele = ele[0];
      } else {
        ele = null;
      }
    }
    if (!ele) {
      ele = wrap.querySelectorAll(`div[data-id*='${id}`);
      if (ele?.length) {
        ele = ele[0];
      } else {
        ele = null;
      }
    }
    return ele;
  };

  const handleScroll = useCallback((id: string) => {
    try {
      let ele = getMsgEl(id);
      console.log(`tj:>>>handleScroll>>`, ele);
      if (!ele) {
        return;
      }
      ele.scrollIntoView({
        block: "center",
        inline: "center"
      });
      setTimeout(() => {
        setLoadingHistory(false);
      }, 100);
    } catch (e) {}
  }, []);

  const maintainScroll = useCallback(
    (id: string, force = false) => {
      const curr: any = scrollRef.current;
      const wrap: any = wrapRef.current;
      if (!curr || !wrap) {
        return;
      }
      const scrollTop = curr.scrollTop;
      if (scrollTop > 10 && !force) {
        return;
      }
      handleScroll(id);
      preScrollTop.current = curr.scrollTop;
    },
    [handleScroll]
  );

  // 会话切换
  const selectChanged = useMemo(() => {
    return selectedSession?.sessionId && preSessionId !== selectedSession?.sessionId;
  }, [selectedSession.sessionId, preSessionId]);

  // tj: 增加loading
  const loadHistory = useCallback(
    (startMid, options = {}) => {
      const imService = ImService.getInstance();
      let sessionFilter: any = {};
      if (isAINoticeSession(selectedSession) && !isAIChatSession(selectedSession)) {
        switch (selectedAITab?.pin) {
          case CHAT_NOTICE.ALL_PIN:
            break;
          case CHAT_NOTICE.OTHER_PIN:
            sessionFilter.filterId = [...OTHER_EXCLUDE_TABS_PIN];
            break;
          default:
            sessionFilter.includeId = [selectedAITab?.pin];
        }
        if (selectedSession?.lastReadMsg?.mid) {
          sessionFilter.selectedId = selectedSession?.lastReadMsg;
        }
        options.sessionFilter = sessionFilter;
      }
      const isCustomApp = isCustomAppSession(selectedSession, customAppList);
      return imService.loadHistory(selectedSession.sessionId, startMid, isCustomApp, options);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedSession, selectedAITab?.pin, customAppList]
  );

  // 计算是否有新的ai消息
  const computeHasNewAIMessage = useCallback(
    (nextAIAllMessage: ChatMessage[]) => {
      if (isAINoticeSession(selectedSession)) {
        if (prevAISessionMessages.length !== nextAIAllMessage.length) {
          updatePreAISessionMsg({ prevAISessionMessages: nextAIAllMessage });
          return true;
        }
      }
      return false;
    },
    [selectedSession, prevAISessionMessages, updatePreAISessionMsg]
  );

  // 如果有新ai消息，同步更新tab
  const syncSelectedAITab = useCallback(
    (nextAIAllMessage: ChatMessage[]) => {
      if (
        computeHasNewAIMessage(nextAIAllMessage) &&
        selectedAITab.pin !== CHAT_NOTICE.ALL_PIN &&
        preSelectedSessionId !== selectedSession.sessionId
      ) {
        updateSelectedAITab({ selectedAITab: { pin: CHAT_NOTICE.ALL_PIN } });
      }
    },
    [
      selectedAITab,
      computeHasNewAIMessage,
      updateSelectedAITab,
      preSelectedSessionId,
      selectedSession
    ]
  );

  // ai助手tab切换
  useEffect(() => {
    if (!isAINoticeSession(selectedSession)) {
      return;
    }
    if ((preSelectedAIPIN && preSelectedAIPIN !== selectedAITab?.pin) || selectChanged) {
      currPage.current = 0;
      setLoadingHistory(true);
      loadHistory(-1, { cancel: true }).then(({ messages }: any) => {
        if (messages?.length > 0) {
          setHistoryMessage({ sessionId, historyMessage: messages });
          currPage.current = 1;
          console.log(
            "tj:>>>>>[messagecontainer]>>>unreadCountRef.current",
            unreadCountRef.current,
            readMsgCustom
          );
          if (unreadCountRef.current > 0 && readMsgCustom === "first") {
            // 定位
            const timer = setTimeout(() => {
              maintainScroll("new-msgs-line", true);
              clearTimeout(timer);
            }, 60);
          } else if (!selectedSession?.unreadCountFork) {
            setTimeout(() => {
              scrollBottom(true, 0);
            }, 60);
          }
        }
        setLoadingHistory(false);
      });
    }
  }, [
    preSelectedAIPIN,
    selectedSession,
    loadHistory,
    setHistoryMessage,
    sessionId,
    scrollInToView,
    selectChanged,
    selectedAITab?.pin,
    scrollBottom,
    readMsgCustom
  ]);

  // 切换加载
  useEffect(() => {
    setEnd(0);
    if (!sessionId || isAINoticeSession(selectedSession)) {
      return;
    }
    // 页面加载以后 加载历史消息 只有会话第一次打开以后加载历史数据
    if (sessionMessages.length > 0 || sMid !== -1) {
      // 如果存在消息数据，不加载历史记录, 初始化end状态
      currPage.current = 0;
    } else {
      setLoadingHistory(true);
    }
    const noChange = selectedSession?.sessionId === preSessionId;
    if (sMid === -1 && selectedSession?.sessionId !== preSessionId) {
      setFirstLoading(true);
      if (sessionMessages.length > 0) {
        setLoadingAgain(true);
        sleep(300).then(() => {
          scrollBottom(true, 0, false);
        });
        sleep(100).then(() => {
          setLoadingAgain(false);
        });
      }
    }
    lastLocalMsgRef.current = null;
    lastLocalElRef.current = null;
    firstRef.current = true;
    bottomEnd.current = 0;
    let offset = selectedSession.lastMid - selectedSession.lastReadMid;
    offset = offset > 20 ? offset : 20;
    const _sMid = sMid > 0 ? sMid - 20 : sMid;
    const count = selectedSession?.unreadCount ? selectedSession?.unreadCount + 20 + offset : 20;
    const options =
      sMid === -1
        ? {
            queryType: 2,
            cancel: firstRef.current ? false : true,
            count,
            timestamp: sTimestamp,
            mergeMessage: !noChange
          }
        : { queryType: 1, reload: true, count, timestamp: sTimestamp };
    loadHistory(_sMid, options).then(async ({ messages, end }: any) => {
      setLoadingHistory(false);
      if (messages?.length > 0) {
        setHistoryMessage({
          sessionId,
          historyMessage: messages.filter((m: any) => m.statusType !== MessageStatus.TEMP)
        });
        if (_sMid !== -1) {
          const msg = messages.find((i: any) => {
            if (i.plusList) {
              return i.plusList.findIndex((ii: any) => ii.messageId === sMid) !== -1;
            } else {
              return Number(i.mid) === Number(sMid);
            }
          });
          lastLocalMsgRef.current =
            messages.filter((m: any) => m.category !== "system").slice(-1)[0] || null;
          // 定位第一条未读
          console.log(
            "tj:>>>[messagecontainner]>>",
            unreadCountRef.current > 0 && readMsgCustom === "first"
          );
          if (unreadCountRef.current > 0 && readMsgCustom === "first") {
            // 定位
            const timer = setTimeout(() => {
              maintainScroll("new-msgs-line", true);
              clearTimeout(timer);
            }, 10);
          } else {
            if (msg) {
              const timer = setTimeout(() => {
                maintainScroll(msg.id, true);
                clearTimeout(timer);
              }, 10);
            }
          }
        }
        if (mountedRef.current && _sMid === -1) {
          setEnd(end);
        }
        firstRef.current = false;
      } else {
        setHistoryMessage({ sessionId, historyMessage: [] });
      }
      if (sessionId.indexOf(CHAT_NOTICE.AI_PIN) > -1) {
        syncSelectedAITab(messages || []);
      }
      if (_sMid === -1 && selectedSession?.sessionId !== preSessionId) {
        scrollBottom(true, 0);
        setTimeout(() => {
          setFirstLoading(false);
        }, 60);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSession?.sessionId, sMid, sTimestamp, llmSetting]);

  // useEffect(() => {
  //   if (!loadGreetRef.current && values(llmSetting).length && isAIChatSession(selectedSession)) {
  //     loadGreetRef.current = true;
  //     getShareHintMessageBody(currentEmployee, llmSetting).then((msg) => {
  //       const historyMessage = [...sessionMessages, msg];
  //       setHistoryMessage({
  //         sessionId: selectedSession.sessionId,
  //         historyMessage
  //       });
  //     });
  //   }
  // }, [currentEmployee, llmSetting, selectedSession, sessionMessages, setHistoryMessage]);
  /**
   * 处理滚动事件
   */
  // eslint-disable-next-line complexity
  useEffect(() => {
    if (firstRef.current && !selectChanged) {
      return;
    }
    if (!prevSessionMessages?.length && !sessionMessages?.length) {
      return;
    }
    // 如果前置状态为空，当前状态有值，假定为页面初始化， 后续加入页面缓存之后需要变更本逻辑
    const isPlusOne = lastPlusCount > (preLastPlusCount || 0);
    const sessionLast = selectedSession.lastMsg || lastMessage;
    const fromMe =
      lastMessage.id !== prevLastMessage.id && isEqualEmployee(lastMessage.sender, currentEmployee);
    const isLast = sessionLast.mid <= lastMessage.mid || lastMessage.mid === 0;
    // 如果消息长度没变化
    if (
      (!lastAIMessage &&
        !isPlusOne &&
        prevSessionMessages?.length === sessionMessages?.length &&
        prevLastMessage.id === lastMessage.id) ||
      isDownloadSysMesssage(lastMessage) ||
      isSnapchatTimeSysMesssage(lastMessage)
    ) {
      return;
    }
    const isGreatLoad =
      (lastMessage as any)?.type === TYPE_KEY_SHARE_GREET_MULTI &&
      prevLastMessage.id !== lastMessage.id;
    // 如果前置状态头部一致尾部不一致，假定有新消息
    if (prevFirstMessage.id && prevFirstMessage.id !== firstMessage.id) {
      maintainScroll(prevFirstMessage.id, prevFirstMessage.mid > firstMessage.mid);
      return;
    }
    if (
      (!!lastAIMessage && !isShareHintMultiMessage(lastAIMessage)) ||
      (fromMe && isLast) ||
      isPlusOne ||
      (prevLastMessage.id !== lastMessage.id && isLast)
    ) {
      setTimeout(() => {
        const force =
          isGreatLoad || fromMe || ["pending", "loading"].includes(lastAIMessage?.flag || "");
        scrollBottom(force, 0, !lastAIMessage);
        if (fromMe) {
          bottomEnd.current = 1;
        }
      }, 30);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentEmployee,
    firstMessage.id,
    firstMessage.mid,
    lastMessage.id,
    lastPlusCount,
    preLastPlusCount,
    prevFirstMessage.id,
    prevFirstMessage.mid,
    prevLastMessage.id,
    prevSessionMessages.length,
    sessionMessages.length,
    selectChanged,
    lastAIMessage,
    selectedSession.lastMsg
  ]);

  const checkBottom = useCallback(() => {
    const cu: any = scrollRef.current;
    if (!cu) {
      return true;
    }
    const scrollTop = cu.scrollTop;
    const cHight = cu.clientHeight;
    const sHight = cu.scrollHeight;
    const _isShowBackBottom = scrollTop + cHight >= sHight - 60;
    return _isShowBackBottom;
  }, []);

  const checkScroller = debounce(() => {
    const _isShowBackBottom = checkBottom();
    setShowBackBottom(!_isShowBackBottom);
  }, 1000);

  const onScrollEnd = useCallback(
    (scrollTop = 0, cHight = 0, sHight = 0) => {
      const _isShowBackBottom = scrollTop + cHight >= sHight - 60;
      setShowBackBottom(!_isShowBackBottom);
      if (_isShowBackBottom) {
        doReadUnread();
        updateSelectSessionInfo({
          session: {
            unreadCountFork: 0,
            sessionId
          }
        });
        unreadCountRef.current = 0;
        // if (skipAnchorId?.msgId && skipAnchorId?.skipId) {
        //   const el = getMsgEl(skipAnchorId?.skipId);
        //   if (el) {
        //     const checked = isInViewPortOfOne(scrollRef.current, el);
        //     if (checked) {
        //       setStartMessageId({
        //         skipAnchorId: {}
        //       });
        //     }
        //   }
        // }
      }
    },
    [doReadUnread, sessionId, updateSelectSessionInfo]
  );

  const observer = useMemo(() => {
    if (isAINoticeSession(selectedSession)) {
      return;
    }
    return new IntersectionObserver(
      (changes: IntersectionObserverEntry[]) => {
        changes.forEach((entry) => {
          if (entry.isIntersecting) {
            updateSelectSessionInfo({
              session: {
                unnreadCountPseudo: 0,
                sessionId: selectedSession.sessionId
              }
            });
            observer?.unobserve(entry.target);
          }
        });
      },
      {
        root: document.getElementById("message-box-container-scroll"),
        threshold: 0
      }
    );
  }, [selectedSession, updateSelectSessionInfo]);

  const handleObserver = debounce(
    useCallback(() => {
      // if (canUnreadBtn) {
      const count = Number(`-${selectedSession.unnreadCountPseudo}`);
      if (!prevSessionMessagesRef.current?.length) {
        prevSessionMessagesRef.current = sessionMessages.slice(count);
      }
      const unreadMsgs2 = prevSessionMessagesRef.current.slice(count);
      const id = unreadMsgs2[0]?.id;
      const cu: any = scrollRef.current;
      if (!cu) {
        return;
      }
      const ele: Element = cu.querySelectorAll(`div[id^='item-${id}`)?.[0] || null;
      if (ele) {
        observer?.observe(ele);
      }
      // }
    }, [
      // canUnreadBtn,
      observer,
      selectedSession.unnreadCountPseudo,
      // selectedSession.unreadCount,
      sessionMessages
    ]),
    300
  );

  // 回到原消息监听
  const skipObserver = useMemo(() => {
    if (isAINoticeSession(selectedSession)) {
      return;
    }
    return new IntersectionObserver(
      (changes: IntersectionObserverEntry[]) => {
        changes.forEach((entry) => {
          if (entry.isIntersecting) {
            setStartMessageId({
              skipAnchorId: {},
              sMid: -1,
              sText: ""
            });
          }
        });
      },
      {
        root: document.getElementById("message-box-container-scroll"),
        rootMargin: "80px 0px 80px 0px",
        threshold: 0
      }
    );
  }, [selectedSession, setStartMessageId]);

  const handleSkipObserver = debounce(
    useCallback(() => {
      if (skipAnchorId?.msgId) {
        const skipEle: Element = getMsgEl(skipAnchorId?.msgId);
        if (skipEle) {
          skipObserver?.observe(skipEle);
        }
      }
    }, [skipObserver, skipAnchorId?.msgId]),
    300
  );

  useEffect(() => {
    if (selectedSession.unnreadCountPseudo && sessionMessages?.length) {
      const count = Number(`-${selectedSession.unnreadCountPseudo}`);
      prevSessionMessagesRef.current = sessionMessages.slice(count);
      if (readMsgCustom === "last" || skipAnchorId?.skipId) {
        setTimeout(() => {
          handleObserver();
        }, 1000);
      }
      console.log(`tj:>>>[messagecontainer]>>>prevSessionMessagesRef.current>`, prevSessionMessagesRef.current)
    }
  }, [handleObserver, readMsgCustom, selectedSession.unnreadCountPseudo, sessionMessages.length]); // eslint-disable-line

  useEffect(() => {
    if (skipAnchorId?.msgId) {
      sleep(100).then(() => {
        handleSkipObserver();
      });
    }
  }, [skipAnchorId?.msgId, handleSkipObserver]);

  const onScroll = useCallback(() => {
    if (firstRef.current) {
      firstRef.current = false;
      return;
    }
    if (!sessionMessages || sessionMessages?.length <= 0) {
      return false;
    }
    if (loadingHistory) {
      return;
    }
    const cu: any = scrollRef.current;
    if (!cu) {
      return;
    }
    const isAIChat = isAIChatSession(selectedSession);
    const scrollTop = cu.scrollTop;
    const cHight = cu.clientHeight;
    const sHight = cu.scrollHeight;
    const isUp = preScrollTop.current === 0 || preScrollTop.current >= scrollTop;
    onScrollEnd(scrollTop, cHight, sHight);
    preScrollTop.current = scrollTop;
    const options: Partial<LoadHistoryOptions> = {};
    const messages = sessionMessages.filter((i) => i.mid > 0);
    const firstId = !messages[0]
      ? -1
      : messages[0].beforeMid > 0
      ? messages[0].beforeMid
      : messages[0].mid - 1;
    const lastMsg = (sessionMessages || []).slice(-1)[0] || {};
    const firstMsg = (sessionMessages || [])[0] || {};
    let startMid = -1;
    if (isUp && scrollTop < 10) {
      if (end > 0) {
        return;
      }
      startMid = isAINoticeSession(selectedSession) ? -1 : firstId;
      setLoadingHistory(true);
      const options = {
        offset: currPage.current,
        timestamp: firstMsg?.timestamp,
        mergeMessage: false
      };
      // 滚动加载
      loadHistory(startMid, options).then(({ messages, end }: any) => {
        if (messages?.length > 0) {
          setHistoryMessage({ sessionId, historyMessage: messages });
          setEnd(end);
          if (isAINoticeSession(selectedSession) || isOrgChatSession(selectedSession)) {
            currPage.current += 1;
          }
        }
        setLoadingHistory(false);
      });
    } else if (!isUp && bottomEnd.current === 0) {
      if (isAIChat) {
        return;
      }
      // 定位处理
      let flag = false;
      const lastMsg = (sessionMessages || []).slice(-1)[0] || {};
      if (lastLocalMsgRef.current) {
        if (!lastLocalElRef.current || lastLocalElRef.current.id !== lastLocalMsgRef.current.id) {
          lastLocalElRef.current = getMsgEl(lastLocalMsgRef.current.id);
        }
      }
      if (!lastLocalElRef.current) {
        lastLocalElRef.current = getMsgEl(lastMsg?.id);
      }
      const startMid = isAINoticeSession(selectedSession)
        ? -1
        : lastLocalMsgRef.current
        ? lastLocalMsgRef.current?.mid - 1
        : lastMsg
        ? lastMsg.mid - 1
        : -1;
      if (
        lastLocalElRef.current &&
        typeof lastLocalElRef.current.getBoundingClientRect === "function"
      ) {
        const refTop = lastLocalElRef.current.getBoundingClientRect().top;
        if (refTop <= cHight + 100) {
          flag = true;
        }
      }
      if (!flag || startMid >= lastMsg?.mid) {
        return;
      }
      setLoadingHistory(true);
      options.queryType = 1;
      options.offset = currPage.current;
      options.timestamp = lastMsg?.timestamp;
      options.mergeMessage = false;
      loadHistory(startMid, options).then(({ messages, end }: any) => {
        if (messages?.length > 0) {
          setHistoryMessage({ sessionId, historyMessage: messages });
          lastLocalMsgRef.current =
            messages.filter((m: any) => m.category !== "system").slice(-1)[0] || null;
          bottomEnd.current = end;
        }
        setLoadingHistory(false);
      });
    }
    if (isUp && selectedSession.unnreadCountPseudo && readMsgCustom === "last") {
      handleObserver();
    }
  }, [
    end,
    loadHistory,
    loadingHistory,
    onScrollEnd,
    selectedSession,
    sessionId,
    sessionMessages,
    setHistoryMessage,
    readMsgCustom,
    handleObserver
  ]);

  const intersectionObserverRef = useMemo(() => {
    if (isAINoticeSession(selectedSession)) {
      return;
    }
    return new IntersectionObserver(
      (changes: IntersectionObserverEntry[]) => {
        changes.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove("hidden");
          } else {
            entry.target.classList.add("hidden");
          }
        });
      },
      {
        root: document.getElementById("message-box-container-scroll"),
        rootMargin: "800px 0px 800px 0px",
        threshold: 0
      }
    );
  }, [selectedSession]);

  useEffect(() => {
    return () => {
      intersectionObserverRef?.disconnect();
    };
  }, [intersectionObserverRef]);
  // 优化计算
  const content = useMemo(() => {
    return getMessageNode({
      messages: sessionMessages || [],
      getLock: getLock,
      unLock: unLock,
      getCurrentMessageId: getCurrentMessageId,
      setCurrentMessageId: setCurrentMessageId,
      session: selectedSession,
      currentEmployee: currentEmployee,
      updateSessionMessagesTimestamp: updateSessionMessagesTimestamp,
      observer: intersectionObserverRef,
      sText: sText,
      sMid: sMid,
      tempMsgs: prevSessionMessagesRef.current
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    intersectionObserverRef,
    sessionMessages,
    getLock,
    unLock,
    getCurrentMessageId,
    setCurrentMessageId,
    selectedSession,
    currentEmployee,
    updateSessionMessagesTimestamp
  ]);

  // const isMainShow = useMemo(() => {
  //   return preMainWinShow === false && mainWinShow;
  // }, [preMainWinShow, mainWinShow]);

  const doOnMainWinShow = debounce(doReadAll, 100);

  // useEffect(() => {
  //   if (isMainShow) {
  //     // doOnMainWinShow();
  //   }
  // }, [isMainShow, doOnMainWinShow]);

  const docMousedown = (e: any) => {
    setonMousedown(true);

    document.addEventListener("mousemove", move);
    function move() {
      setonMousedown(false);
    }

    document.addEventListener("mouseup", onMouseup);
    function onMouseup(evt: any) {
      document.onmousemove = null;
      document.onmouseup = null;
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseup", onMouseup);
    }
  };

  useEffect(() => {
    if (selectedSession.isNotice && isAINoticeSession(selectedSession)) {
      if (preCustomAppList && preCustomAppList.length > customAppList.length) {
        doReadAll();
      }
    }
  }, [selectedSession, customAppList, preCustomAppList, doReadAll, mainWinShow]);

  useEffect(() => {
    let doc: any = wrapRef.current;
    if (selectChanged) {
      doOnMainWinShow();
    }
    if (doc?.className === "message-box-container") {
      doc?.addEventListener("mousedown", docMousedown);
    }
    return () => {
      doc?.removeEventListener("mousedown", docMousedown);
    };
  }, [doOnMainWinShow, selectChanged]);

  const handleContainerClick = useCallback(() => {
    // 点击聊天框时关闭更多操作
    lockRef.current = false;
    bus.emit("chat:message-container-click");
    if (isMousedown === false) return;
    window.getSelection()?.empty();
    setonMousedown(false);
  }, [isMousedown]);

  // 屏蔽tab按键
  const onKeyDown = useCallback((e) => {
    if (e.keyCode === 9) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
  }, []);

  useEffect(() => {
    // 按键处理
    window.addEventListener("keydown", onKeyDown);
    mountedRef.current = true;
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      mountedRef.current = false;
      canUnreadBtnRef.current = false;
      prevSessionMessagesRef.current = null;
      unreadMsgs = null;
      unreadCountRef.current = 0;
      preScrollTop.current = 0;
      bottomEnd.current = 0;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  // 自动消失
  useEffect(() => {
    if (showBottomTimerRef.current) {
      clearTimeout(showBottomTimerRef.current);
      showBottomTimerRef.current = null;
    }
    if (isShowBackBottom) {
      showBottomTimerRef.current = setTimeout(() => {
        clearTimeout(showBottomTimerRef.current);
        showBottomTimerRef.current = null;
        setShowBackBottom(false);
      }, 3 * 1000);
    }
  }, [isShowBackBottom]);

  const handleGoFirst = () => {
    const count = Number(`-${selectedSession.unnreadCountPseudo}`);
    if (!prevSessionMessagesRef.current.length) {
      prevSessionMessagesRef.current = sessionMessages.slice(count);
    }
    const unreadMsgs2 = prevSessionMessagesRef.current.slice(count);
    const id = unreadMsgs2[0]?.id;
    maintainScroll(id, true);
    updateSelectSessionInfo({
      session: {
        unnreadCountPseudo: 0,
        sessionId
      }
    });
    setStartMessageId({
      sMid: -1,
      sText: "",
      skipAnchorId: {}
    });
  };
  const handleGoEnd = useCallback(() => {
    const lastMsg = (sessionMessages || []).slice(-1)[0] || {};
    bottomEnd.current = 1;
    if (
      lastLocalMsgRef.current ||
      (lastMsg.mid !== selectedSession.lastMid &&
        (lastMsg.statusType || "").toLowerCase() !== MessageStatus.TEMP.toLowerCase())
    ) {
      lastLocalMsgRef.current = null;
      lastLocalElRef.current = null;
      loadHistory(-1, { offset: 0, queryType: 2, mergeMessage: false }).then(
        ({ messages, end }: any) => {
          setHistoryMessage({ sessionId, historyMessage: messages });
          setEnd(end);
          scrollBottom(true, 0);
        }
      );
    } else {
      scrollBottom(true, 0);
    }
    updateSelectSessionInfo({
      session: {
        unreadCountFork: 0,
        sessionId
      }
    });
    unreadCountRef.current = 0;
    doReadUnread();
    setShowBackBottom(false);
    setStartMessageId({
      sMid: -1,
      sText: "",
      skipAnchorId: {}
    });
  }, [
    doReadUnread,
    loadHistory,
    scrollBottom,
    selectedSession.lastMid,
    sessionId,
    sessionMessages,
    setHistoryMessage,
    updateSelectSessionInfo,
    setStartMessageId
  ]);

  const unreadCount = useMemo(() => {
    const isBottom = checkBottom();
    return isBottom ? selectedSession.unreadCount : selectedSession?.unreadCountFork || 0;
  }, [checkBottom, selectedSession.unreadCount, selectedSession.unreadCountFork]);

  const unreadCountRef = useRef(unreadCount);

  useEffect(() => {
    if (prevLastMessage.id && prevLastMessage.id !== lastMessage.id) {
      unreadCountRef.current = !unreadCountRef.current ? unreadCount : unreadCountRef.current + 1;
    }
  }, [lastMessage.id, prevLastMessage.id, unreadCount]);

  // 处理未读数
  useEffect(() => {
    if ((selectedSession?.unnreadCountPseudo || 0) === 0 && unreadCountRef.current !== 0) {
      unreadCountRef.current = 0;
    }
  }, [selectedSession?.unnreadCountPseudo]);

  const showUnreadBtn = useMemo(() => {
    const fromMe = isEqualEmployee(lastMessage.sender, currentEmployee);
    return !fromMe;
  }, [
    currentEmployee,
    lastMessage.sender
    // selectedSession.unreadCountFork
  ]);

  const showBottomUnread = useMemo(() => {
    return ((unreadCount || 0) > 0 || isShowBackBottom) && !skipAnchorId?.msgId;
  }, [isShowBackBottom, unreadCount, skipAnchorId?.msgId]);

  const showToEndBtn = useMemo(() => {
    const condition = (unreadCount || 0) > 0 || isShowBackBottom;
    return condition;
  }, [isShowBackBottom, unreadCount]);

  const showPseudoBtn = useMemo(() => {
    const fromMe = isEqualEmployee(lastMessage.sender, currentEmployee);
    return (
      !fromMe &&
      selectedSession?.unnreadCountPseudo &&
      selectedSession?.unnreadCountPseudo >= MAX_AI_UNREAD_COUNT
    );
  }, [currentEmployee, lastMessage.sender, selectedSession.unnreadCountPseudo]);

  useEffect(() => {
    if (canUnreadBtnRef.current) return;
    if (readMsgCustom === "last" && selectedSession.unreadCount) {
      canUnreadBtnRef.current = false;
    } else {
      canUnreadBtnRef.current = true;
    }
  }, [
    // canUnreadBtn,
    readMsgCustom,
    selectedSession.unreadCount,
    sessionId
  ]);
  const resetUnreadCountRef = () => {
    unreadCountRef.current = 0;
  };

  useEffect(() => {
    bus.on("session:openNewWindow", resetUnreadCountRef);
    return () => {
      bus.off("session:openNewWindow", resetUnreadCountRef);
    };
  }, []);

  return (
    <div className="message-box-container" onClick={handleContainerClick} ref={wrapRef}>
      <div
        className={classNames(
          `message-box-container-scroll reply-popover ${firstLoading ? "isLoading" : ""} ${
            loadingAgain ? "isLoadingAgain" : ""
          }`
        )}
        id="message-box-container-scroll"
        ref={scrollRef}
        onScroll={throttle(onScroll, 150)}
      >
        <div>
          {selectedSession.isSecret && (
            <div className="secret-session-desc">
              <div>
                <IconFont type="iconic_app_im_burnafterreading_facet" />
              </div>
              <div>阅后即焚-沟通更安全</div>
              <div>
                <span style={{ display: "block" }}>·消息支持阅后即焚 ·服务器不留操作痕迹</span>
                <span style={{ display: "block" }}>·消息不支持转发 ·会话限制截屏操作</span>
              </div>
            </div>
          )}
          {sessionMessages?.length > 0 ? (
            <div className="today-messages-nodes" id="today-messages-nodes">
              {/* {end > 0 && <TimeLine timeStamp={sessionMessages[0].timestamp} />} */}
              {content}
            </div>
          ) : !isAIChatSession(selectedSession) &&
            isAINoticeSession(selectedSession) &&
            !loadingHistory ? (
            <div className="ai-empty-wrapper">
              {/* <div className="empty-png">
                                <img src={aiEmpty} alt="" width="100%" />
                            </div>
                            <div className="arrows-png">
                                <img src={aiArrows} alt="" width="100%" />
                            </div> */}
              <div className="no-data-png">
                <img src={aiNoData} alt="" width="100%" />
              </div>
              <p className="empty-text">
                暂无内容
                {selectedAITab.pin !== CHAT_NOTICE.ALL_PIN && (
                  <>
                    <br />
                    请切换至“全部”查看
                  </>
                )}
              </p>
            </div>
          ) : null}
          {loadingHistory && (
            <div className="loading-wrap">
              <Loading type="message" />
            </div>
          )}
        </div>
      </div>
      {sessionMessages?.length > 0 && (
        <>
          {skipAnchorId?.msgId ? (
            <div className="message-bottom-wrap bottom">
              <GoEnd
                onGoEnd={() => {
                  maintainScroll(skipAnchorId?.msgId, true);
                  setStartMessageId({ sMid: -1, skipAnchorId: {} });
                }}
                text="回到引用消息"
              />
            </div>
          ) : null}
          {readMsgCustom === "last" && selectedSession.unnreadCountPseudo ? (
            <div className="message-bottom-wrap top">
              <GoEnd
                onGoEnd={handleGoFirst}
                newMessage={
                  selectedAITab.pin === CHAT_NOTICE.ALL_PIN ? selectedSession.unnreadCountPseudo : 0
                }
              />
              {isLLMAI && showPseudoBtn && !isAINoticeSession(selectedSession) ? (
                <AISummaryControl
                  tipText="未读摘要"
                  type="message"
                  fixMsgs={prevSessionMessagesRef.current}
                  message={lastUnreadMessage}
                  unnreadCountPseudo={selectedSession.unnreadCountPseudo}
                />
              ) : null}
            </div>
          ) : null}
          {canUnreadBtnRef.current ? (
            <div
              className={`message-bottom-wrap ${
                (unreadCountRef.current || 0) > 0 ? "bottom" : "other"
              } ${
                showBottomUnread &&
                (selectedAITab.pin === CHAT_NOTICE.ALL_PIN ? unreadCountRef.current : 0) === 0
                  ? "go-end-border"
                  : ""
              }`}
            >
              {showBottomUnread && (
                <GoEnd
                  onGoEnd={handleGoEnd}
                  newMessage={
                    selectedAITab.pin === CHAT_NOTICE.ALL_PIN ? unreadCountRef.current : 0
                  }
                />
              )}
              {isLLMAI &&
              showUnreadBtn &&
              unreadCountRef.current >= MAX_AI_UNREAD_COUNT &&
              !isAINoticeSession(selectedSession) ? (
                <AISummaryControl
                  tipText="未读摘要"
                  type="message"
                  message={lastUnreadMessage}
                  accUnreadCount={unreadCountRef.current}
                />
              ) : null}
            </div>
          ) : null}
        </>
      )}
      <ChattingRecordsModal />
      {/* {isLLMAI && isAINoticeSession(selectedSession) && !isAIChatSession(selectedSession) ? (
        <FloatButton offsetRight={20} onClick={handleAIEnter}>
          <div className="btn-ai-chat" />
        </FloatButton>
      ) : null} */}
    </div>
  );
}

function mapStateToProps({ chat, user }: any) {
  const {
    selectedSession,
    sessionMessageMap,
    mainWinShow,
    selectedAITab,
    allSessionList,
    preSelectedSessionId,
    prevAISessionMessages,
    sMid,
    sText,
    sTimestamp,
    updateSessionMessagesTimestamp,
    lastUnreadMessage,
    customAppList,
    llmSetting,
    skipAnchorId
  } = chat as ChatState;
  let sessionMessages: any[] = sessionMessageMap[selectedSession.sessionId] || [];
  if (isAINoticeSession(selectedSession) && !isAIChatSession(selectedSession)) {
    const selectedPin = selectedAITab.pin || CHAT_NOTICE.ALL_PIN;
    sessionMessages = filterNoticeMassagesByType(sessionMessages, selectedPin);
    if (selectedPin === CHAT_NOTICE.ALL_PIN) {
      const newMessage: any[] = [];
      sessionMessages.forEach((msg) => {
        if (
          customAppList.findIndex((item) => (item.info as Employee).userId === msg.from?.pin) === -1
        ) {
          newMessage.push(msg);
        }
      });
      sessionMessages = newMessage;
    }
  }
  return {
    readMsgCustom: user.readMsgCustom,
    sessionMessages,
    selectedSession,
    mainWinShow,
    allSessionList,
    selectedAITab,
    sessionMessageMap,
    preSelectedSessionId,
    prevAISessionMessages,
    sMid,
    sText,
    sTimestamp,
    updateSessionMessagesTimestamp,
    lastUnreadMessage,
    customAppList,
    llmSetting,
    skipAnchorId
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    async setHistoryMessage(data: { sessionId: string; historyMessage: ChatMessage }) {
      await dispatch({ type: "chat/setHistoryMessage", payload: data });
    },
    async updateSelectedAITab(data: { selectedAITab: AITabState }) {
      await dispatch({ type: "chat/updateSelectedAITab", payload: data });
    },
    async updatePreAISessionMsg(data: { prevAISessionMessages: ChatMessage[] }) {
      await dispatch({ type: "chat/updatePreAISessionMsg", payload: data });
    },
    async initSelectedSession(data: { selectedSession: any }) {
      await dispatch({ type: "chat/initSelectedSession", payload: data });
    },
    async updateSessionEvent(data: { session: any }) {
      await dispatch({ type: "chat/updateSessionEvent", payload: data });
    },
    launchNoticeSession(data: { sid: string }) {
      dispatch({ type: "chat/launchNoticeSession", payload: data });
    },
    updateSelectSessionInfo(data: any) {
      dispatch({ type: "chat/updateSelectSessionInfo", payload: data });
    },
    setStartMessageId(data: { sMid: number; sText: string; sTimestamp: number }) {
      dispatch({ type: "chat/setStartMessageId", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageBoxContainer);
